/** @format */
import React from 'react';
import PropTypes from 'prop-types';

const PropertyBuildingIcon = ({ 
  className = "h-7 w-7", 
  count = null,
  showPinkAccent = false 
}) => {
  return (
    <div className="relative">
      <svg 
        className={className} 
        viewBox="0 0 32 32" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
        role="img"
        aria-label="Property building icon with client count"
      >
        {/* Main building structure */}
        <path
          d="M6 26V10c0-1.1.9-2 2-2h16c1.1 0 2 .9 2 2v16"
          stroke="currentColor"
          strokeWidth="1.5"
          fill="none"
        />
        
        {/* Building roof */}
        <path
          d="M4 26h24"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        
        {/* Windows - arranged in luxury residential pattern */}
        <rect x="10" y="12" width="2.5" height="3" fill="currentColor" opacity="0.6" rx="0.5" />
        <rect x="14" y="12" width="2.5" height="3" fill="currentColor" opacity="0.6" rx="0.5" />
        <rect x="18" y="12" width="2.5" height="3" fill="currentColor" opacity="0.6" rx="0.5" />
        
        <rect x="10" y="17" width="2.5" height="3" fill="currentColor" opacity="0.6" rx="0.5" />
        <rect x="14" y="17" width="2.5" height="3" fill="currentColor" opacity="0.6" rx="0.5" />
        <rect x="18" y="17" width="2.5" height="3" fill="currentColor" opacity="0.6" rx="0.5" />
        
        <rect x="10" y="22" width="2.5" height="3" fill="currentColor" opacity="0.6" rx="0.5" />
        <rect x="14" y="22" width="2.5" height="3" fill="currentColor" opacity="0.6" rx="0.5" />
        <rect x="18" y="22" width="2.5" height="3" fill="currentColor" opacity="0.6" rx="0.5" />

        {/* Entrance door */}
        <rect 
          x="22" 
          y="20" 
          width="3" 
          height="6" 
          fill={showPinkAccent ? "rgb(204, 29, 185)" : "currentColor"} 
          opacity={showPinkAccent ? "1" : "0.8"} 
          rx="1.5"
        />
        
        {/* Door handle */}
        <circle 
          cx="24" 
          cy="23" 
          r="0.5" 
          fill="white" 
          opacity="0.9"
        />
        
        {/* Luxury detail - architectural accent */}
        <path
          d="M8 8 L16 4 L24 8"
          stroke="currentColor"
          strokeWidth="1.5"
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
      
      {/* Contextual count overlay */}
      {count !== null && (
        <div className="absolute -top-1 -right-1 bg-primary text-white text-xs font-montserrat-medium rounded-full min-w-[18px] h-[18px] flex items-center justify-center px-1">
          {count}
        </div>
      )}
    </div>
  );
};

PropertyBuildingIcon.propTypes = {
  className: PropTypes.string,
  count: PropTypes.number,
  showPinkAccent: PropTypes.bool,
};

export default PropertyBuildingIcon;